module.exports = __webpack_public_path__ + "img/galeria-aquario-1.e8e68611.jpg";